<template>
  <div
    class="nav__brands p-2 lg:py-0 z-10 col-span-12 lg:col-span-7 row-start-2 lg:row-start-1 col-start-1 lg:flex justify-start items-center"
    qaid="nav-brand-logos"
  >
    <h2 class="lg:hidden nav-section-title font-bold relative mb-[1rem] text-lg my-1">
      {{ $t('nav.mobile.shopOurBrands') }}
    </h2>
    <ul
      class="nav__brands-logos list-none grid gap-3 items-stretch grid-cols-2 md:grid-cols-4 lg:flex py-2 lg:py-0"
      :role="isCompactView ? 'menu' : null"
    >
      <li
        v-for="logo in logos"
        :key="logo.identifier"
        class="block lg:grid text-center place-content-center py-0"
        :role="isCompactView ? 'none' : null"
      >
        <a
          :href="composeLink(logo.href)"
          :tabindex="!isCompactView ? 0 : isMobileNavOpen ? 0 : -1"
          :aria-label="logo.aria"
          :role="isCompactView ? 'menuitem' : null"
          :qaid="`${logo.title}-logo`"
          class="grid justify-center lg:justify-start items-center nav__mobile-item py-3 lg:py-0"
          :target="setTarget(logo.target)"
          @keydown.prevent.down="
            (e) => {
              !isCompactView ? '' : focusNextMobileMenuItem(e);
            }
          "
          @keydown.prevent.up="
            (e) => {
              !isCompactView ? '' : focusPreviousMobileMenuItem(e);
            }
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            role="img"
            :aria-labelledby="`nav-${logo.identifier}`"
            :width="logo.width"
            :height="logo.height"
            :viewBox="logo.viewBox"
            :class="`nav-${logo.identifier}`"
          >
            <title :id="`nav-${logo.identifier}`">{{ logo.title }}</title>
            <g v-if="logo.identifier === BrandName.TREK">
              <path
                d="m76.454 0-3.98 11h-7.755L68.7 0h7.753Zm15.905 0-8.913 5.182L88.594 11h-8.951L75.04 5.12 83.275 0h9.084ZM67 0l-.763 2.105H53.935l-.833 2.292h12.303L64.644 6.5H52.348l-.504 1.387c-.182.505.14 1.016.82 1.016h11.114L63.018 11H47.115c-.642 0-1.024-.292-1.346-.652-.18-.203-1.068-1.205-1.19-1.346-.364-.414-.33-.963-.158-1.447L47.149 0H67ZM43.44 0c1.103 0 1.733.658 1.344 1.755-.236.671-.961 2.71-1.288 3.535-.288.723-.908 1.311-2.012 1.311H40.253l-.16-.001h-.437l-.125-.001h-.392L43.05 11H34.35l-4.594-5.872.776-.001h1.03l.232-.001.957-.001H33.884l.2-.001h.954c.658 0 1.117-.348 1.306-.807.14-.339.334-.878.473-1.33.137-.444-.103-.882-.706-.882h-5.637L27.275 11h-7.554l3.985-11H43.44ZM22.329 0l-.763 2.105h-6.805L11.541 11h-7.32l3.217-8.895H0L.762 0H22.33Z"
              />
            </g>
            <g v-if="logo.identifier === BrandName.ELECTRA">
              <path
                d="M12.369 12.997s-2.603.468-3.87.702c-1.602.3-5.94 1.27-5.806-.601.033-.668.6-1.737 1.835-3.274 2.435-.3 8.108-.902 10.143-.534.534.1 1.134.334 1.334.467-.066-.668-1.568-1.403-2.368-1.603-.601-.134-2.436-.735-7.007-.568 1.334-1.303 2.936-2.873 4.004-4.242 1.735-.134 7.24-1.103 8.908.233-.5-1.904-3.67-2.371-4.17-2.438-.267.033-1.402-.1-3.404-.067 0-.1 0-.601-.467-.768 0 0-.4-.134-.667-.034-.034 0-.534.401-1.101.902a54.436 54.436 0 0 0-3.47.334c-.5.067-1.368.602-1.001 1.17.333.534.934.768 1.968.835-.7.734-2.435 2.538-3.97 4.376-.667.066-1.401.133-2.135.233-.868.1-1.502.769-.868 1.337.033.066.267.367 1.368.5C-.344 12.83-.243 14.3.691 15.303c.634.668 2.602.902 4.938.501 1.601-.267 6.606-1.47 7.14-2.138.3-.334.4-.701-.4-.668Zm62.726.769c-1.3.568-3.803.3.701-5.679.467-.601.8-1.17.8-1.637-.867-.1-1.067.134-1.968-.033-.067.3-.033.568-.434.835 0 0-.1-.368-.267-.635-.233-.367-1.3-1.837-5.338-.167-1.501.702-5.272 3.207-6.072 6.714-.568.368-1.168.635-1.735.668-3.437.334-2.57-2.973 2.936-6.246 0 0 .3-.2.6-.434.534-.435-1.935-1.07-5.171-.268-1.101.268-1.502-.367-1.368-.902.133-.434.667-.734.667-.734s-3.537 0-3.837 2.037c-.1.635.1 1.07.467 1.37C53.908 10.459 49.638 14.7 47.87 14c-.6-.234-.367-1.203.534-2.372 1.235-1.604 4.17-4.944 6.373-7.35a97.877 97.877 0 0 0 2.435-.166c2.37-.134 8.142-1.203 11.078.5-2.169-1.369-3.704-1.803-5.84-2.104-1.968-.3-3.169-.4-5.738-.3.234-.234.4-.401.534-.501.434-.535.467-1.07.167-1.203-.668-.3-1.735-.534-1.902-.5-.167.033-.868 1.001-1.134 1.269-.1.1-.568.6-1.102 1.169-.133 0-.3.033-.433.033-.668.067-2.603.334-5.539.234-.667-.034-1.335-.2-1.568-.1-.2.1-.968.768-.067 1.336.901.568 3.203.635 4.705.568.333 0 .667-.034 1-.034-.1.134-.2.234-.2.268-.133.2-3.17 3.975-4.57 6.346-4.338 3.808-8.776 3.207-9.076 1.938-.133-.635-.033-1.938 2.102-3.942 2.135-2.004 4.504-2.372 5.005-2.271.4.066.334.267.233.5-.2.535-1.3 1.504-1.534 1.738-.5.5-.468 1.035.967 1.336-.4-.434.034-.668.634-1.136 1.735-1.47 1.835-1.804 1.935-2.338.167-.768-.534-1.637-2.202-1.67-3.336-.067-6.506 2.338-8.575 4.676-.934 1.07-1.334 1.904-1.468 2.606-.4.2-.867.4-1.301.568-8.008 2.805-5.572-2.105-5.572-2.105.567.368 1.869.568 2.703.501 4.07-.4 6.506-3.474 6.105-5.244-.3-1.303-1.935-1.637-4.237-.969-4.004 1.203-6.94 4.844-7.24 7.45-.901.634-2.27 1.469-3.57 1.636-.668.067-3.103.267-2.636-3.374 0 0 12.545-3.808 10.577-9.854 0 0-.367-.935-1.769-.802-2.102.2-4.771 1.67-7.607 4.476-1.735 1.704-3.337 3.742-3.837 6.648 0 0-2.402 1.37-1.902 2.472.067-.368.367-.668.868-1.036.333-.2.767-.4.867-.4-.1 1.135 1.035 3.64 4.004 3.273 1.835-.234 3.437-.935 5.005-2.171.2 1.436 1.535 2.304 4.304 1.77 2.702-.501 4.504-1.57 5.238-2.071.034.3.134.534.2.735.367.735 1.268 1.637 3.47 1.537 3.304-.168 5.94-1.637 7.608-2.907-.334 1.07-.267 2.205.4 2.673 1.502 1.002 5.639.033 10.043-6.28.968.033 2.202-.301 3.437-.902-4.605 3.741-3.37 7.215-1.268 7.415 1.434.134 2.702-.6 3.87-1.703 0 1.002.534 1.704 1.168 1.837.767.167 2.77.1 6.84-3.14.233-.167.367-.133.267.3-.534 2.94 2.802 3.976 4.938 1.738.567-.602 2.335-2.706 4.404-2.706-2.336-.3-4.237 1.57-4.905 1.87Zm-46.778-3.608c.934-1.937 3.437-3.173 3.437-3.173 3.036-1.704 4.404-.602 1.968 1.47-3.37 2.906-5.472 1.87-5.405 1.703Zm-9.075-.267c2.736-6.046 8.575-8.351 9.075-8.284 1.101.167-1.635 5.244-8.975 8.317-.133.067-.1-.033-.1-.033Zm47.812 3.574c-1.368.735-2.102.3-1.935-.935.2-1.604 1.268-2.539 2.536-3.608 2.87-2.438 4.938-1.837 5.171-1.637 1.168.969-3.37 4.877-5.772 6.18Z"
              />
            </g>
            <g v-if="logo.identifier === BrandName.BONTRAGER">
              <path
                d="M95.422 0c1.93 0 3.534.397 4.895 1.061L98.76 3.232c-.94-.517-2.195-.866-3.426-.866-3.185 0-5.542 2.601-5.542 5 0 1.482.988 2.35 2.94 2.35.696 0 1.484-.155 2.132-.423l.825-1.87h-3.42l1.015-2.269h6.319l-2.658 5.963c-1.215.494-2.868.883-4.749.883-3.733 0-5.663-1.848-5.663-4.643 0-3.33 3.226-7.357 8.89-7.357ZM24.533 0c3.735 0 5.47 1.912 5.47 4.635 0 3.329-3.265 7.357-8.337 7.357-3.736 0-5.47-1.92-5.47-4.635 0-3.33 3.266-7.357 8.337-7.357Zm99.45.324c2.156 0 3.582 1.053 3.582 2.771 0 2.098-1.426 3.769-4.667 4.254-.024 1.766.494 3.087 1.377 4.319h-3.151c-.56-1.062-.924-2.26-.917-4.076l-3.062.276-1.692 3.8h-3.129L117.372.324h6.611Zm-9.317 0-1.053 2.374h-7.284l-.933 2.099 6.296-.032-.997 2.251-6.304.033-.98 2.205h7.682l-1.078 2.414H99.214L104.262.325h10.404Zm-31.397 0 1.206 11.344h-3.062l-.162-2.205h-5.728l-1.775 2.205h-3.581L79.808.325h3.46Zm-14.399 0c2.156 0 3.581 1.053 3.581 2.771 0 2.098-1.425 3.769-4.666 4.254-.023 1.766.494 3.087 1.378 4.319h-3.152c-.56-1.062-.924-2.26-.916-4.076l-3.064.276-1.693 3.8h-3.126L62.259.324h6.611Zm-8.629 0-1.069 2.414h-4.164l-3.971 8.93h-3.112l3.971-8.93h-4.619l1.07-2.414h11.895Zm-22.209 0 2.366 6.798 3.03-6.797h3.063l-5.048 11.343h-2.576l-2.73-7.869-3.5 7.869h-3.064L34.621.325h3.411Zm-26.057 0c2.285 0 3.468.94 3.468 2.408 0 1.288-.948 2.3-2.439 2.842.778.39 1.337 1.038 1.32 2.1-.016 1.912-2.034 3.994-5.752 3.994H0L5.048.324h6.927Zm12.307 1.96c-2.73 0-4.828 2.917-4.828 5.082 0 1.36.737 2.34 2.463 2.34 2.73 0 4.829-2.915 4.829-5.08 0-1.36-.737-2.342-2.464-2.342Zm-13.458 4.31-5.655.48-1.02 2.286H8.87c1.459 0 2.327-.836 2.327-1.882 0-.347-.107-.663-.374-.883ZM80.79 2.926l-3.453 4.286h3.76l-.307-4.286Zm42.594-.38h-3.872l-1.338 2.997 4.311-.405c1.272-.12 2.017-.842 2.033-1.669.008-.616-.413-.923-1.134-.923Zm-55.113 0h-3.874l-1.336 2.997 4.31-.405c1.273-.12 2.019-.842 2.036-1.669.008-.616-.414-.923-1.136-.923Zm-56.944-.05H7.203l-1.087 2.44 4.44-.39c1.136-.097 1.824-.608 1.824-1.304 0-.478-.315-.746-1.053-.746Z"
              />
            </g>
            <g v-if="logo.identifier === BrandName.DIAMANT">
              <path
                d="M112.8 45.8c5 0 9.1-4.1 9.1-9.1s-4.1-9.1-9.1-9.1-9.1 4.1-9.1 9.1c0 5.1 4.1 9.1 9.1 9.1zm291 38.1c-1.5 0-3.2-.6-4.2-1.8-.9-1.1-2.1-2.8-1.4-6.3 1.2-5.8 2.6-10.3 5.3-15.8 15.5-1.7 24.5-9.1 24.5-9.1l-2-3.1c-7 3.3-14 4.3-19.9 4.2.3-1 .9-2.6 1.9-4.6 2.7-5.4 5.9-11.5 8.5-15.9 0 0-1.4-1.2-3.7-1.7-7.6-1.6-12.7 1.7-12.7 1.7s-6.4 9.6-9.5 16.8v.1c-3.1-1.2-5.3-2.2-5.3-2.2-2.2 3.7-3.6 7-4.6 11.4 2 .7 3.7 1.1 5.6 1.5-5.3 12.9-5 19.2-5 19.2l-2.6 2.5c-1.4 1.2-4.1 3-7 3-1.8 0-3.7-1.4-3.6-4.2.1-2.3 6-14.2 6.1-18.6.1-3.7-2.5-9-9.7-8.7-3.2.1-6.8 1.2-10.7 3.5-2.7 1.6-5.6 3.8-8.9 6.6.1-.2.1-.5.1-.8.8-2.1 1.7-4.1 2.6-6.6 0 0-1.4-1.2-3.7-1.7-7.6-1.6-12.7 1.7-12.7 1.7s-6.5 14.5-9.6 25.2c-.8.7-4.2 3.7-7.8 3.7-1.9 0-3.6-1.5-3.6-4.8 0-6 8.7-24 8.7-24s-1.4-1.2-3.7-1.7c-7.6-1.6-12.7 1.7-12.7 1.7l-1.3 2.5c-1.7-3.4-5.1-5.2-10.1-5.5-6.5-.4-13.9 1.4-20.7 6.8a25.3 25.3 0 0 0-9.9 19.5v.4c-.7.6-2 1.9-2.2 2.1-1.4 1.2-4.1 3-7 3-1.9 0-4-1.6-3.6-4.8V79c.6-4.3 5.8-13.7 5.9-17.9.1-3.7-2.5-9-9.7-8.7-3.2.1-6.8 1.2-10.7 3.5-2.7 1.6-5.6 3.8-8.9 6.6.2-.7.3-1.6.3-2.9 0-1.5-.4-2.8-1.1-3.9-.7-1.1-3.2-3.6-8.5-3.5-3.4.1-7.2 1.4-11.5 4-4.2 2.5-5.6 4.1-8.7 7.6.9-2.4 2.4-5.9 3.5-8.6 0 0-1.4-1.2-3.7-1.7-7.6-1.6-12.7 1.7-12.7 1.7s-6.8 16.3-9.4 24.9l-.1.2c-.9.8-4.2 3.7-7.8 3.7-1.9 0-3.6-1.5-3.6-4.8 0-6 8.7-24 8.7-24s-1.4-1.2-3.7-1.7c-7.6-1.6-12.7 1.7-12.7 1.7l-1.3 2.5c-1.7-3.4-5.1-5.2-10.1-5.5-6.5-.4-13.9 1.4-20.7 6.8-6.7 5.3-9.9 12.7-9.9 19.4 0 1 .3 1.8.3 1.8-1.7 1.8-4.8 4-8.2 3.5-1.3-.2-2.6-.9-3.1-2.4-.6-1.8-.7-4.3 1.1-9.6 2.2-6.6 8.3-16.6 8.3-16.6s-1.4-1.2-3.7-1.7c-7.6-1.6-12.7 1.7-12.7 1.7s-6.1 7-8.8 17.9C81 86.7 89 92.4 94.2 93.2c2 .3 3.9.2 6.1-.2 2.2-.4 4-1.3 4.7-1.7 4-2.2 4.1-2.6 5.6-3.9.7-.7 1.4-1.4 2-2.1.3.6.6 1.1.9 1.7 1.7 2.5 4 4.3 6.9 5.4 1.1.4 4.1 1 5.6 1 3.5 0 7.1-1.1 10.7-3.2 3.2-1.8 6-4.3 8.5-7.4.3 2.1.4 6.5 5.6 9.5 5.5 2.7 12 0 13.7-1 4-2.2 5.4-3.7 5.6-3.9l-2 6.1c7.2.1 13.4-.4 18.6-1.7.6-3.2 1.3-6 1.9-8.8 1.3-5.2 3.7-9.8 7.7-13.4 3.8-3.4 7.1-5.3 8.4-6 1.6-.8 3.2.5 2.6 2-3.9 10.1-6 15.7-8.5 28 6.7-.1 12.7-.6 18-2.1 0 0 .1-1.6 1.5-7.6 1.2-5.2 1.8-9 5.9-13.6 2.8-3.1 6.5-5.2 8.2-6.2 1.8-1 3.1.3 2.4 2.1-4.4 11.1-6.5 18.8-2.5 23.4 2.2 2.6 5.5 3.7 9.1 3.8 9.8 0 16.7-5.5 19.9-8.4.3.7.7 1.5 1.1 2.2 1.7 2.5 4 4.3 6.9 5.4 1.1.4 4.1 1 5.6 1 3.5 0 7.1-1.1 10.7-3.2 3.2-1.8 6-4.3 8.5-7.4.3 2.1.4 6.5 5.6 9.5 5.5 2.7 12-.1 13.7-1 4.5-2.5 5.6-4 5.6-4v.3c-1.1 3.7-2 5.9-2 5.9 7.2.1 13.4-.4 18.6-1.7l1.4-.4s0-.2.1-.6c.1-.9.5-2.9 1.4-7 .3-1.2.5-2.3.8-3.4l.4-1.7c.8-2.9 2-5.5 4.7-8.4 2.8-3.1 6.5-5.2 8.2-6.2 1.8-1 3.1.3 2.4 2.1-4.4 11.1-6.5 18.8-2.5 23.4 2.4 2.7 6 3.8 9.7 3.8 9 0 16.1-5.6 19.3-8.4v-.1c1.5 4.8 5.9 8.1 10.7 8.5 13.5 1 22.6-7.1 30-14.4l-2.6-3.2c-3.7 3-9.3 7.9-15.8 7.9zM144.9 72.3c-4 7.9-8.9 9.7-11.3 9.8-3.1.2-4.5-2.4-4.5-5.2 0-3.8 1.1-7.4 4.1-11.8 3.1-4.4 7.4-7.2 10.2-7.2 5.7 0 4.3 8.9 1.5 14.4zm149 .1c-4 7.9-8.9 9.7-11.3 9.8-3.1.2-4.5-2.4-4.5-5.2 0-3.8 1.1-7.4 4.1-11.8 3.1-4.4 7.4-7.2 10.2-7.2 5.8 0 4.3 8.9 1.5 14.4zM13.4 11.2c-9.2 7-14 17.6-9.9 26.9 3.8 8.7 12.2 9 16.5 6.4 3.6-2.1 5-6.3 5-6.3s-7.8-2.2-7-10.5c1.4-13.4 27.5-22.2 43.1-7.4 18.5 17.7 4.7 49.1-10.3 57-8.8 4.6-14.7 5.7-22.4 5 0 0 4.6-11.2 12.6-29.7 6.9-15.8 13.1-29.2 13.1-29.2s-2.4-2-7.1-2c-7.3 0-10.8 2.2-10.8 2.2S30 36.8 23 52.6C11.7 77.9 6.1 93 6.1 93c37.9 10.1 71.5-6 78-36.6C93.6 11.2 44-12.2 13.4 11.2z"
              />
            </g>
            <g v-if="logo.identifier === BrandName.TREK_TRAVEL">
              <path
                d="M483 30v4l2.6 26h.6l2.8-26v-4l-2.8-26h-.6L483 30ZM391.1 5h-39.6l-20.4 56.3h39.7L391.1 5ZM383.9 31.2l23.5 30.1h45.8l-26.3-29.8L472.5 5H426l-42.1 26.2ZM338.9 15.8 342.8 5H241.2l-14 38.6c-.9 2.5-1.1 5.3.8 7.4.6.7 5.2 5.8 6.1 6.9 1.6 1.8 3.6 3.3 6.9 3.3h81.3l3.9-10.7h-56.9c-3.5 0-5.1-2.6-4.2-5.2l2.6-7.1h62.9l3.9-10.8h-62.9l4.3-11.7h63v.1ZM222.2 5H121.3l-20.4 56.3h38.6l16.4-45.5h28.8c3.1 0 4.3 2.2 3.6 4.5-.7 2.3-1.7 5.1-2.4 6.8-1 2.3-3.3 4.1-6.7 4.1h-27l23.5 30h44.5l-20-22.5h12c5.6 0 8.8-3 10.3-6.7 1.7-4.2 5.4-14.6 6.6-18.1 2-5.5-1.2-8.9-6.9-8.9ZM114.3 5H3.9L0 15.8h38.1L21.6 61.3h37.5l16.5-45.5h34.8L114.3 5ZM601.9 30.8c4.4-2.2 11.5-6.4 11.5-14.6C613.4 5.6 602.6 1 588.7 1c-7.6 0-23.2.2-23.2.2v1.3s5.2.5 7.3 2.2c1.9 1.5 2.4 3.5 2.7 9.5.2 3.3.4 10.8.4 17.3 0 5.1-.1 13.2-.4 16.7-.3 3.4-.3 7-2.6 8.8-2.1 1.6-6.9 1.7-6.9 1.7v1.2h28.9v-1.2s-3-.2-5.6-1c-3.9-1.1-4-5.4-4.3-9.7-.2-2.5-.4-12.5-.4-12.5l8.2-1.4C646.5 96.3 678 48.3 678 48.3l-1.2-.9c0 .1-27.8 39.6-74.9-16.6Zm-6.9-1.1-10.3 2s0-20 .2-27.7c7.5 0 18.3 3 18.3 14.1 0 8.4-5.7 10.7-8.2 11.6ZM804.9 53c-.5-11-.4-17.8-.4-23.4 0-4.4 0-10.6.4-17.1.2-4 .5-6.9 2.6-8 2.5-1.3 7.4-1.7 7.4-1.7V1.6H786v1.2s4.5.2 6.9 1.7c1.7 1.1 2.2 3.5 2.2 8.1.2 8.1.2 13.9.2 17.4 0 5 .1 12.6-.2 18.1-.4 6-1.3 7.5-2.9 8.7-2.2 1.6-7 1.8-7 1.8v1.3h9.5c3.3 0 10.8.9 15.6 2.1 2.6.7 5.3 1 8.2 1 13.6 0 20.9-7.2 26.3-14.7l-1.1-1c-13 19.2-38.8 5.7-38.8 5.7Z"
              />
              <path
                d="M628.4 32c-1.7 4.2-3.2 6.2-4.6 7.2-1.8 1.2-4.7 1.3-4.7 1.3v.9h18v-.9c-1.2-.2-5.1-.1-5.1-3.8 0-.7.4-1.9.6-2.9.7-2.5 2.4-6.6 2.8-7.6h13.8c.3.7 1.1 2.8 2.3 6.4.6 1.4 1 3 1 4.3 0 3.4-4.3 3.4-6.1 3.7v.9h22.1v-.9c-2.5-.2-6.3-1.1-8.5-6.9-3.1-7.9-7.8-20.4-9.8-25.8-.2-.4-.2-.9-.2-1.4 0-1.9 1.5-3.6 3.6-3.6h.2v-.1l-.3-1.2h-22.3v1.2s8.9-.6 6.9 4.4c-1.7 5-6.8 17.8-9.7 24.8Zm13.9-24.4 5.8 14.8h-11.5c2.2-6 5.7-14.8 5.7-14.8ZM766.4 1.7c5.9 0 7.7-.1 8.8-1.7h.9l-.8 13.6h-1.1s-.2-4.8-2.3-6.3c-1.9-1.4-4.9-1.6-8.1-1.8-2.1-.1-4.9-.1-7.3-.1h-5.8c-.3 7.3-.5 15.9-.5 22.8l14.4-.3c1 0 3-.1 4.2-1.3 1.3-1.5 1.6-3.1 2-5.3h1.1V39.1h-1.1c0-.1 0-.2-.1-.3-.1-.7-.4-2.1-1-3.6-.2-.5-.5-1-.9-1.5-1.1-1.1-3.2-1.3-4.2-1.3l-14.4-.2c0 .9-.1 9.9.3 15.7.3 6.3 1.3 8.7 9.8 8.7 5.7 0 11.3-1.2 15.1-4.5 2.1-1.8 3.7-5.8 3.7-5.8l1.1.5-4.4 13.2h-45.7v-1.2s6.1-.3 8.2-1.9c2.1-1.7 2.4-4.6 2.6-8.1.3-3.7.5-10 .5-17.2 0-7.4 0-10.2-.2-17.9 0-.6-.1-1.2-.1-1.7 0-5-4-8.9-8.9-8.9-.7 0-1.4.1-2.1.2h-.2c-.9.3-1.7.7-2.5 1.1-3.1 1.8-5.1 4.4-9 12.1-7.2 14.5-20.2 44-20.2 44l-2.2.3s-.9-2.1-3-7.4c-3.3-8.1-14-31.6-17-38.1-1.9-4-4.6-9.1-7.3-10.6-3.5-1.8-7.7-1.9-7.7-1.9V1.6h28.5v1.2c-2.6.3-5.7 1.4-5.7 4.8 0 1.5.6 3.7 1.7 6.5 6.5 15.7 14.8 32.2 14.8 32.2s5.8-12.1 13.2-29.8c1.4-3.5 2.6-6.9 2.6-8.9 0-3.1-2.1-4.5-6.7-4.8V1.6l57 .1ZM557 1.1h-52.5l-4.4 13.8 1 .5s1.6-4.1 3.7-5.9c3.8-3.3 6.4-4.6 12-4.6 8.3 0 8.5 2.3 8.9 8.5V49c-.2 3.9-.6 6.7-2.7 8-2.4 1.3-7.3 1.6-7.3 1.6v1.3h29.2v-1.3s-4.5-.2-6.8-1.6c-1.8-1.3-2.2-3.6-2.3-8.1V13.3c.3-6.1.6-8.4 8.9-8.4 5.7 0 8.1 1.3 11.9 4.6 2.1 1.8 3.8 5.9 3.8 5.9l1-.5L557 1.1Z"
              />
            </g>
          </svg>
        </a>
      </li>
    </ul>

    <slot
      v-if="isCompactView"
      name="mobile-login"
      :focus-next-mobile-menu-item="focusNextMobileMenuItem"
      :focus-previous-mobile-menu-item="focusPreviousMobileMenuItem"
      :toggle-mobile-nav="toggleMobileNav"
    />
    <slot
      v-if="isCompactView"
      name="mobile-language"
      :focus-next-mobile-menu-item="focusNextMobileMenuItem"
      :focus-previous-mobile-menu-item="focusPreviousMobileMenuItem"
      :toggle-mobile-nav="toggleMobileNav"
    />
  </div>
</template>
<script>
import {mapState} from 'vuex';
import {BrandName} from '@/navigation/utils/nav-constants.js';
import links from '@/navigation/mixins/links.js';
export default {
  name: 'NavBrandLogos',
  mixins: [links],
  inject: ['isMobileNavOpen'],
  props: {
    isMobileNavOpen: {
      type: Boolean,
      default: false,
    },
    focusNextMobileMenuItem: {
      type: Function,
      default: () => {},
    },
    focusPreviousMobileMenuItem: {
      type: Function,
      default: () => {},
    },
    toggleMobileNav: {
      type: Function,
      default: () => {},
    },
    brandUrls: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    isElectraSupportedSite: {
      type: Boolean,
      default: false,
    },
    isTrekTravelLocale: {
      type: Boolean,
      default: false,
    },
    isDiamantLocale: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      BrandName,
    };
  },
  computed: {
    ...mapState('global', ['isCompactView']),
    ...mapState('backend', ['kioskModeEnabledOnSite']),

    logos() {
      const logos = [
        {
          identifier: BrandName.TREK,
          href: this.brandUrls.trekBrandNavURLClear,
          title: this.$t('general.logo.text'),
          aria: this.$t('nav.logo.altText'),
          height: '11',
          width: '93',
          viewBox: '0 0 93 11',
        },
      ];
      if (this.isElectraSupportedSite) {
        logos.push({
          identifier: BrandName.ELECTRA,
          href: this.brandUrls.electraBrandNavURLClear,
          title: this.$t('general.logo.text.electra'),
          aria: this.$t('nav.logo.altText.electra'),
          height: '16',
          width: '80',
          viewBox: '0 0 80 16',
        });
      }

      logos.push({
        identifier: BrandName.BONTRAGER,
        href: this.brandUrls.bontragerBrandNavURLClear,
        title: this.$t('general.logo.text.bontrager'),
        aria: this.$t('nav.logo.altText.bontrager'),
        height: '12',
        width: '128',
        viewBox: '0 0 128 12',
      });

      if (this.isDiamantLocale) {
        logos.push({
          identifier: BrandName.DIAMANT,
          href: this.brandUrls.diamantBrandURL,
          title: this.$t('general.logo.text.diamant'),
          aria: this.$t('general.logo.text.diamant'),
          target: 'NEWWINDOW',
          height: '18',
          width: '79',
          viewBox: '0 0 430 98',
        });
      }

      if (this.isTrekTravelLocale && !this.kioskModeEnabledOnSite) {
        logos.push({
          identifier: BrandName.TREK_TRAVEL,
          href: this.brandUrls.trekTravelBrandNavURL,
          title: this.$t('nav.logo.altText.trekTravel'),
          aria: this.$t('nav.logo.altText.trekTravel'),
          height: '12',
          width: '154',
          viewBox: '0 0 845 66',
        });
      }
      return logos;
    },
  },
};
</script>
<style lang="scss">
.nav__brands {
  --nav-focus-color: var(--white);
  --nav-focus-offset: 2px;

  opacity: var(--nav-opacity);
  background: var(--nav-brands-bg);
  color: var(--nav-brands-color);

  .nav__brands-logos {
    color: var(--nav-brands-logos-color);

    li {
      background: var(--nav-brands-logos-bg);

      a {
        transition: color 0.2s ease;
      }

      @media (screen(lg)) {
        @media (hover: hover) {
          a:hover {
            color: var(--white);
          }
        }
      }

      .nav-diamant-logo {
        margin-top: -2px;
      }
    }
  }
}
</style>
